// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.head h3 {
  margin: 5px;
}
.head h1 {
  font-size: 18px;
  color: grey;
}

.menu {
  display: flex;
  flex-direction: column;
}

.menu p {
  width: 50%;
}

.menu span {
  width: 50%;
}

.menu button {
  color: grey;
  text-align: left;
  font-style: oblique;
  font-size: medium;
  margin: 5px;
  width: 95%;
}
.menu button mat-icon {
  margin-right: 5px;
  vertical-align: middle;
}

.menu-1,
.menu-2,
.menu-3,
.menu-4,
.menu-5 {
  display: flex;
  flex-wrap: wrap;
}

.field-properties {
  margin: 10px;
  display: flex;
  flex-direction: column;
}

mat-divider {
  margin-top: 9.5px;
  margin-bottom: 7px;
}

.drag-placeholder-section {
  opacity: 0;
}

.drag-placeholder-field {
  opacity: 0;
}

.head-properties {
  margin: 10px;
  display: flex;
  flex-direction: column;
}

::ng-deep .head-properties .mat-form-field-label {
  font-size: 14px !important;
  font-weight: bold;
}

::ng-deep .head-properties .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 14px !important;
}

/** this block use for resize mat-input*/
::ng-deep .head-properties .mat-form-field-flex > .mat-form-field-infix {
  padding: 0.7em 0px !important;
}

::ng-deep .head-properties .mat-form-field-label-wrapper {
  top: -1em;
}

::ng-deep .head-properties .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.5em) scale(0.75);
  width: 133.33333%;
}

::ng-deep .head-properties .mat-form-field-wrapper {
  padding-bottom: 1px;
}

::ng-deep .field-container-table {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-control/form-control.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,uBAAA;EACA,eAAA;AACH;AACG;EACG,WAAA;AACN;AAEG;EACG,eAAA;EACA,WAAA;AAAN;;AAIA;EACG,aAAA;EACA,sBAAA;AADH;;AAIA;EACG,UAAA;AADH;;AAIA;EACG,UAAA;AADH;;AAIA;EACG,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AADH;AAEG;EACG,iBAAA;EACA,sBAAA;AAAN;;AAIA;;;;;EAKG,aAAA;EACA,eAAA;AADH;;AAIA;EACG,YAAA;EACA,aAAA;EACA,sBAAA;AADH;;AAIA;EACG,iBAAA;EACA,kBAAA;AADH;;AAIA;EACG,UAAA;AADH;;AAIA;EACG,UAAA;AADH;;AAIA;EACG,YAAA;EACA,aAAA;EACA,sBAAA;AADH;;AAIA;EACG,0BAAA;EACA,iBAAA;AADH;;AAIA;EACG,0BAAA;AADH;;AAIA,wCAAA;AACA;EAA0E,6BAAA;AAA1E;;AACA;EAA2D,SAAA;AAG3D;;AADA;EACI,yCAAA;EACA,iBAAA;AAIJ;;AADA;EACG,mBAAA;AAIH;;AADA;EACG,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAIH","sourcesContent":[".head {\n   display: flex;\n   justify-content: center;\n   flex-wrap: wrap;\n\n   h3 {\n      margin: 5px;\n   }\n\n   h1 {\n      font-size: 18px;\n      color: grey;\n   }\n}\n\n.menu {\n   display: flex;\n   flex-direction: column;\n}\n\n.menu p {\n   width: 50%;\n}\n\n.menu span {\n   width: 50%;\n}\n\n.menu button {\n   color: grey;\n   text-align: left;\n   font-style: oblique;\n   font-size: medium;\n   margin: 5px;\n   width: 95%;\n   mat-icon {\n      margin-right: 5px;\n      vertical-align: middle;\n   }\n}\n\n.menu-1,\n.menu-2,\n.menu-3,\n.menu-4,\n.menu-5{\n   display: flex;\n   flex-wrap: wrap;\n}\n\n.field-properties {\n   margin: 10px;\n   display: flex;\n   flex-direction: column;\n}\n\nmat-divider {\n   margin-top: 9.5px;\n   margin-bottom: 7px;\n}\n\n.drag-placeholder-section {\n   opacity: 0;\n}\n\n.drag-placeholder-field {\n   opacity: 0;\n}\n\n.head-properties {\n   margin: 10px;\n   display: flex;\n   flex-direction: column;\n}\n\n::ng-deep .head-properties .mat-form-field-label {\n   font-size: 14px !important;\n   font-weight: bold;\n}\n\n::ng-deep .head-properties .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 14px !important;\n}\n\n/** this block use for resize mat-input*/\n::ng-deep .head-properties .mat-form-field-flex > .mat-form-field-infix { padding: 0.7em 0px !important;}\n::ng-deep .head-properties .mat-form-field-label-wrapper { top: -1em; }\n\n::ng-deep .head-properties .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n    transform: translateY(-1.5em) scale(.75);\n    width: 133.33333%;\n}\n\n::ng-deep .head-properties .mat-form-field-wrapper {\n   padding-bottom: 1px;\n}\n\n::ng-deep .field-container-table {\n   display: flex;\n   flex-direction: row;\n   margin-left: 10px;\n   overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
